import { root, id } from './bucketSize';

export const bucketSize = {
  ...root,
  id: {
    ...id,
  },
};
